import Api from './api/index'
import CCPWebSocket from './CCPWebSocket'
import { isRequired, requiredParams } from './core/helpers'
import { REQUIRED_CONFIG_PARAMS } from './core/constants'

export default class Provider {

  constructor({
    config = isRequired('config'),
    websocketConfig = isRequired('websocketConfig'),
  }) {
    requiredParams(config, REQUIRED_CONFIG_PARAMS)

    // if (!(__AGENT__)) {
    //   requiredParams(websocketConfig, REQUIRED_WEBSOCKET_PARAMS)
    // }

    this.config = { ...config, websocketConfig }

    this.api = new Api(this.config)

    this._websocket = null
  }

  async initWebsocket() {
    if (this.websocket) {
      return
    }

    if (this.config?.websocketConfig?.disabled) {
      return
    }

    let url = this.config.websocketConfig.url
    url = url + '?token=' + this.api.user.requester._token + '&identifier=' + this.api.user.requester._identifier

    this.websocket = new CCPWebSocket(url, this.config.hooks)
    await this.websocket.init()

    return this.websocket
  }

  get websocket() {
    return this._websocket
  }

  set websocket(value) {
    this._websocket = value
  }

  set hooks(hooks) {
    this.config.hooks = hooks
  }
  set handlers(handlers) {
    this.config.handlers = handlers
  }
}
